import { React, useState } from "react";
import { connect } from "react-redux";
import "./style.css";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import Labels from "../../services/apiLabels";
import { PUT } from "../../constant/apiMethods";
import { RESET_PASSWORD } from "../../constant";

export const ChagePassword = ({ passworedReset_New }) => {
  const { feedback } = useContext(FeedbackContext);
  var change_password_page = feedback.change_password_page;
  let { id } = useParams();
  let { token } = useParams();

  document.body.style.background = "#F2F4F5";

  const [email, setemail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const reSetPassword = () => {
    if (submitting) return;
    setSubmitting(true);
    passworedReset_New(
      {
        uidb64: id,
        token: token,
        password: email,
      },
      () => setSubmitting(false)
    );
  };

  return (
    <>
      <div className="containerfluid contact_wrap p-5">
        <h2 className="text-center mt-5">
          {change_password_page.change_pass_text}
        </h2>
        <div className="row text-center d-flex justify-content-center ">
          <div className="col-lg-4 col-md-5 col-sm-12 ">
            <div className="inp_wrap my-3">
              <input
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                }}
                className="inp_contact"
                placeholder={change_password_page.new_pass_placeholder}
                disabled={submitting}
              />
            </div>

            <button
              className=" btn_contact my-3"
              onClick={reSetPassword}
              disabled={submitting}
            >
              {submitting
                ? "Updating…"
                : change_password_page.btn_change_pass}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  passworedReset_New: (data, callBack) =>
    dispatch({
      type: RESET_PASSWORD,
      payload: {
        type: RESET_PASSWORD,
        label: Labels.password_Reset_New,
        method: PUT,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChagePassword);
